<!-- The "m-0!", "p-0!" and "border-none!" classes are to make sure that wrapper element doesn't have any margin/padding/border -->
<!-- because if element is not open it is still in the HTML causing empty space (for example when using space-y-X classes) -->
<!-- Suggestion to solve this issue is to add margin/padding to any child inside <slot /> -->
<!-- Correct: <BaseAccordionAnimation> <AnyChild class="mt-6" /> </BaseAccordionAnimation> -->
<!-- Wrong: <BaseAccordionAnimation class="mt-6"> <AnyChild /> </BaseAccordionAnimation> -->
<template>
  <div
    class="m-0! grid border-none! p-0! transition-[grid-template-rows] duration-300"
    :class="[props.isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]']"
  >
    <div class="overflow-hidden">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  isOpen: boolean
}>()
</script>
